import React from 'react'
import styles from './disapproved.styles'
import injectSheet from 'react-jss'
import bearAndDoor from './bear-and-door.gif'
import Button from 'pobble-components/dist/button'
import Container from '../../components/container/container'
import Title from '../../components/title/title'
import Description from '../../components/description/description'
import { withRouter } from 'react-router'

const Disapproved = ({ classes, history, onClose }) => (
  <Container>
    <img
      className={classes.img}
      src={bearAndDoor}
      alt="Parent approved pupil"
    />
    <Title>Our door is always open</Title>
    <Description>
      <p>
        Thank you, we've registered your preference. You can control it via your
        Pobble account.
      </p>
    </Description>
    <div className={classes.buttons}>
      <Button tall secondary action={() => history.push('/finish-signup')}>
        Set up your Pobble account
      </Button>
    </div>
  </Container>
)

export default withRouter(injectSheet(styles)(Disapproved))
